import React from 'react'
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import {ItemCell} from '../../components/modules/grids/Item';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useCards} from '../../components/hooks/hooks-mongoDB/useCards'
import Scheda from '../../components/modules/scheda/Scheda'; 
import uvaXS from '../../components/images/vitigno/intestato/UvaggioWd500.png';
import uvaS from '../../components/images/vitigno/intestato/UvaggioWd800.png';
import uvaM from '../../components/images/vitigno/intestato/UvaggioWd1200.png';
import uvaL from '../../components/images/vitigno/intestato/UvaggioWd1600.png';
import uvaXL from '../../components/images/vitigno/intestato/UvaggioWd2000.png';
import uvaXXL from '../../components/images/vitigno/intestato/UvaggioWd3500.png';

function Vitigno() {
    const {themes} = useThemes();
     // Componente 1 - Carica theme di tipologia
    const vitigno_Theme = themes[9];
    // Componente 2 - Carica articles di tipologia
    const { articles: articles_Grp } = useArticles('vitigno');
    const articles_Vitigno = articles_Grp || [];
    const { cards: cards_Grp } = useCards('vitigno');
    const cards_Vitigno = cards_Grp || [];

    return (
        <section>
            {vitigno_Theme && <NavHeadLinks title={vitigno_Theme.tema_titolo} picB={uvaXS}  picS={uvaS} picM={uvaM} picL={uvaL} picXL={uvaXL} picXXL={uvaXXL} />}
            <MenuMobile temi={themes}/>
            <Scheda cards={cards_Vitigno}/>
            {vitigno_Theme && <div className = "tema__title mt-2 mb-2"><h1 className = "title__top">{vitigno_Theme.tema_titolo}</h1></div>}
            <div className="layout__grids">
                <ItemCell item={articles_Vitigno}/>
            </div>
        </section>
    )
}
export default Vitigno;
